import styled from 'styled-components'

export const ChartContainer = styled.div`
  color: ${props => props.theme.color};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 0 20px;
`

export const XKey = styled.div`
  margin-top: -10px;
  font-weight: bold;
`

export const YKey = styled.div`
  font-weight: bold;
  transform: rotate(-90deg);
  white-space: nowrap;
  width: 20px;
  position: absolute;
  left: -5px;
  top: 175px;
`
